module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mi equipo")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isShowingJefeDirecto) ? _c('div', {
    staticClass: "message is-info"
  }, [_vm._m(0)]) : _vm._e(), _c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha Ingreso")]), (_vm.isShowingJefeDirecto) ? _c('th', [_vm._v("Jefe directo")]) : _vm._e(), _c('th', [_vm._v("Días por tomar / programar")]), _c('th', {
    staticClass: "td-status"
  })]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.equipo), function(o, index) {
    return _c('tr', {
      key: index + '-desktop',
      staticClass: "row-table",
      class: {
        directo: o.directo, 'row-info': o.esDeDelegacion, 'fw-bold': o.codigoJefe === +_vm.codigoLogueadoJefe
      }
    }, [_c('td', [_c('div', {
      staticClass: "flex aic"
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Equipo Delegado'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(" (" + _vm._s(o.cargo) + ")")])])])]), _c('td', [_vm._v(_vm._s(o.fechaIngreso))]), (_vm.isShowingJefeDirecto) ? _c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_vm._v(_vm._s(o.nombreJefe))])]) : _vm._e(), _c('td', [_vm._v(_vm._s(o.diasReales) + " / " + _vm._s(o.diasDisponibles))]), _c('td', {
      staticClass: "td-status"
    }, [_c('div', {
      staticClass: "status"
    }, [_c('div', {
      staticClass: "circle",
      class: {
        'yellow': o.diasReales >= 35 && o.diasReales <= 40,
          'red': o.diasReales > 40
      }
    })])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.equipo), function(o, index) {
    return _c('div', {
      key: index + '-mobile',
      staticClass: "box has-text-left",
      class: {
        directo: o.directo, 'row-info': o.esDeDelegacion, 'fw-bold': o.codigoJefe === +_vm.codigoLogueadoJefe
      }
    }, [_c('div', {
      staticClass: "dias"
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(o.diasReales) + " ")]), _c('span', [_vm._v("por tomar / ")]), _c('strong', [_vm._v(_vm._s(o.diasDisponibles) + " ")]), _c('span', [_vm._v("por programar ")])]), _c('div', {
      staticClass: "status"
    }, [_c('div', {
      staticClass: "circle",
      class: {
        'yellow': o.diasReales >= 35 && o.diasReales <= 40,
          'red': o.diasReales > 40
      }
    })])]), _c('div', {
      staticClass: "flex aic"
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Equipo Delegado'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('div', {
      staticClass: "mt-10 hint--bottom",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))])])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Cargo: ")]), _c('span', [_vm._v(_vm._s(o.cargo))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Fecha de Ingreso: ")]), _c('span', [_vm._v(_vm._s(o.fechaIngreso))])]), (_vm.codigoLogueadoJefe !== (o.codigoJefe + '')) ? _c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Jefe: ")]), _c('span', [_vm._v(_vm._s(o.nombreJefe))])]) : _vm._e()])
  }), 0), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v("*")]), _c('span', [_vm._v("Los empleados con texto resaltado son empleados directos, es decir, es tu responsabilidad aprobar las solicitudes ")]), _c('span', [_vm._v("de vacaciones de ellos.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24005d6e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Lista_Equipo_Vacaciones.vue
// module id = 768
// module chunks = 0